import React from "react";
import PropTypes from "prop-types";
import Separator from "../../contentBlocks/Separator.react";
import Text from "../../contentBlocks/Text.react";
import ButtonGroup from "../../contentBlocks/ButtonGroup.react";
import SlideHeader from "../../contentBlocks/SlideHeader.react";
import SlideHeaderSidebar from "../../contentBlocks/SlideHeaderSidebar.react";
import { Grid } from "semantic-ui-react";

export default class Brancher extends React.Component {
    static propTypes = {
        colors: PropTypes.shape({
            baseText: PropTypes.string,
            primary: PropTypes.string,
        }).isRequired,
        data: PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            brancher: PropTypes.array.isRequired,
            paragraph: PropTypes.string,
        }).isRequired,
        gotoSlide: PropTypes.func.isRequired,
        slideShow: PropTypes.bool,
        mobileView: PropTypes.bool,
    };
    handleClick = (index) => {
        if (this.props.gotoSlide) {
            let list = this.props.data.brancher || [],
                slideSeq = list[index]["slideLink"];
            this.props.gotoSlide(slideSeq, true);
        }
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let defaultStyle = {
            margin: "auto",
            width: "80%",
            textAlign: "center",
            paddingTop: "50px",
        };
        let defaultLandscapeStyle = {
            margin: "60px auto",
            width: "100%",
            textAlign: "center",
            position: "relative",
            float: "right",
        };
        let title =
            this.props.data.header !== undefined
                ? this.props.data.header
                : this.props.data.title;
        let subtitle =
            this.props.data.subheader !== undefined
                ? this.props.data.subheader
                : this.props.data.subtitle;
        return (
            <div className="full-height">
                {isPortrait ? (
                    <div>
                        <SlideHeader
                            {...this.props}
                            title={title}
                            subtitle={subtitle}
                        />
                        <div style={defaultStyle}>
                            <Text
                                keyName="paragraph"
                                text={this.props.data.paragraph}
                                color={this.props.colors.baseText}
                                fontSize="large"
                                animation="fadeIn,100"
                            />
                            <Separator
                                keyName="separator"
                                color={this.props.colors.primary}
                                animation="fadeIn,100"
                            />
                            <ButtonGroup
                                keyName="brancher"
                                colors={this.props.colors}
                                options={this.props.data.brancher}
                                extractFrom="text"
                                animation="fadeIn,100"
                                callback={this.handleClick}
                                slideShow={this.props.slideShow}
                            />
                        </div>
                    </div>
                ) : (
                    <Grid style={{ minHeight: "100%" }}>
                        <Grid.Row style={{ paddingBottom: "0" }}>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingRight: "0",
                                    background: this.props.colors.primary,
                                }}
                            >
                                <SlideHeaderSidebar
                                    {...this.props}
                                    title={title}
                                    subtitle={subtitle}
                                />
                            </Grid.Column>
                            <Grid.Column width={8} style={{ paddingLeft: "0" }}>
                                <div style={defaultLandscapeStyle}>
                                    <Text
                                        keyName="paragraph"
                                        text={this.props.data.paragraph}
                                        color={this.props.colors.baseText}
                                        fontSize="large"
                                        animation="fadeIn,100"
                                    />
                                    <Separator
                                        keyName="separator"
                                        color={this.props.colors.primary}
                                        animation="fadeIn,100"
                                    />
                                    <ButtonGroup
                                        keyName="brancher"
                                        colors={this.props.colors}
                                        options={this.props.data.brancher}
                                        extractFrom="text"
                                        animation="fadeIn,100"
                                        callback={this.handleClick}
                                        slideShow={this.props.slideShow}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </div>
        );
    }
}
